const m = require('minthril');
const { component } = require('../../component');
const { previewHostname } = require('../../../../shared/preview-slug');
const { CostEstimate } = require('../../components/cost-estimate');
const { CutoverReadiness } = require('../../components/cutover-readiness');
const { HourlyUsageGraph } = require('../../components/hourly-usage-graph');
const { SiteNavigation } = require('../../components/site-navigation');
const { duration } = require('../../components/usage-totals');

function formatDurationAxis(milliseconds) {
  if (milliseconds === 0) return '0';
  if (milliseconds < 1000) return `${Math.round(milliseconds)} ms`;

  const seconds = milliseconds / 1000;
  if (seconds < 60) return `${seconds.toFixed(1)} s`;

  const minutes = seconds / 60;
  if (minutes < 60) return `${minutes.toFixed(1)} min`;

  return `${(minutes / 60).toFixed(1)} h`;
}

const SitePage = component(() => {
  return {
    view: ({ attrs: {
      site,
      stats,
      backHref = '/sites',
      overviewHref = `/sites/${site.id}`,
      trafficHref,
      routesHref,
      costHref,
      settingsHref,
      onRefreshDomain,
      onLoadSpend
    } }) => m('section.panel.site-detail.site-overview',
      m(SiteNavigation, {
        breadcrumbs: [
          { label: backHref.startsWith('/admin') ? 'Admin' : 'Sites', href: backHref },
          { label: site.name }
        ],
        overviewHref,
        trafficHref,
        routesHref,
        costHref,
        settingsHref,
        current: 'overview'
      }),
      m('h2', site.name),
      m('p.site-origin', site.origin),
      m('p.site-preview',
        'Preview: ',
        m('a', {
          href: `https://${previewHostname(site)}`,
          target: '_blank',
          rel: 'noreferrer'
        }, previewHostname(site))
      ),
      stats ? m(CutoverReadiness, { site, stats, onRefreshDomain }) : null,
      stats ? [
        m(HourlyUsageGraph, {
          hourlyUsage: stats.hourlyUsage,
          periodHours: stats.usagePeriodHours
        }),
        m(HourlyUsageGraph, {
          hourlyUsage: stats.hourlyUsage,
          periodHours: stats.usagePeriodHours,
          metric: 'renderDurationMs',
          title: 'Rendering',
          subtitle: 'Hourly render time across all routes',
          metricLabel: 'Render time',
          formatValue: duration,
          formatAxisValue: formatDurationAxis,
          variant: 'rendering'
        })
      ] : null,
      stats ? m('section.panel.site-overview__summary', [
        m('h3', 'Cache snapshot'),
        m('div.site-overview__cache', [
          m('p', `Cached pages: ${stats.pages}`),
          m('p', `Cached HTML: ${(stats.bytes / 1024).toFixed(1)} KB`)
        ]),
        stats.routes.some(route => route.renderFailures) ? m('aside.site-overview__alert', {
          role: 'alert'
        }, [
          m('strong', 'Some routes failed to cache'),
          m('p', 'A recent render made a failed API request or could not complete.'),
          m('ul', stats.routes
            .filter(route => route.renderFailures)
            .map(route => m('li',
              m('a', {
                href: `${routesHref}/route?route=${encodeURIComponent(route.path)}`
              }, route.path),
              ` · ${route.renderFailures} failure${route.renderFailures === 1 ? '' : 's'} · `,
              m('a', {
                href: `${routesHref}/route/logs?route=${encodeURIComponent(route.path)}`
              }, 'View logs')
            )))
        ]) : null,
        m(CostEstimate, { site, onLoad: onLoadSpend })
      ]) : m('p.muted', 'Loading site overview…')
    )
  };
});

module.exports = { SitePage };
